import React, { Fragment, useState } from 'react';
import {Link} from 'react-router-dom';

import axios from 'axios';
import Paciente from './pacientes';

import Moment from 'react-moment';

const Ordenpaciente =({idordenpaciente})=>{
    
    const [informepaciente, guardarInformePaciente]= useState([]);
  
    
    if(idordenpaciente.length===0)  
    
    return  null;
    
   
    const fnVerEstudios = () =>{
        alert('Consultado Estudios')

    }
    
    const  DEscargarEstudios  = async () =>{ 
      // validar
     //asignar id

        const consultaInformes =  await axios.post('https://cebacapi.herokuapp.com/Service.svc/informe.json', {
        "idPaciente" : (Paciente.id),  
        "idOrden" : (idordenpaciente.id)
        },
       );   
        guardarInformePaciente(consultaInformes.data.informe)

          var newBlob = ([consultaInformes.data.informe]);
          var bin = atob(newBlob);
          
      const link = document.createElement('a');
        //link.innerHTML='Descargar PDF file';
        link.download= "file.pdf"
        link.href ='data:application/octet-stream;base64,' + newBlob;
        link.click();
         document.body.appendChild(link);
       //<a href="newsletter_01.pdf" target="_blank">Read more</a>
     
           
    }

    const  VErApi  = async () =>{ 
        // validar
       //asignar id
          var w = window.open();
          const consultaInformes =  await axios.post('http://localhost:4000/Service.svc/informe.json', {
          "idPaciente" : (Paciente.id),  
          "idOrden" : (idordenpaciente.id)
          },
         );   
          guardarInformePaciente(consultaInformes.data.informe)

            var newBlob = ([consultaInformes.data.informe]);
            var bin = atob(newBlob);
            var obj = document.createElement('object');
            obj.style.width = '100%';
            obj.style.height = '842pt';
            obj.type= 'application/pdf';
            obj.data = 'data:application/pdf;base64,' + newBlob;
            
           w.document.body.appendChild(obj);
          /* <progress value="70" max="100">70 %</progress>*/
                             
      }
      function refreshPage(){ window.location.reload(); } 

    

        
        return( 
 
         <Fragment>

     
             
                <form 
                         className="formulario"
                         onSubmit={fnVerEstudios}
                />

                       <tr >
                         
                          <td >{idordenpaciente.numero}</td>
                          <td ><Moment format="DD/MM/YYYY">{idordenpaciente.fecha}</Moment></td>
                          <td ><Moment format="DD/MM/YYYY">{idordenpaciente.fechaEntrega}</Moment></td>

                          <div classname="btn-group btn-group-toggle btn-group-xs" data-toggle="buttons">
                    
                                <button 
                                      type="submit" 
                                      className="btn btn-link"
                                      onClick={() => (VErApi())  }
                                      ><span className="input-group-text" id="basic-addon">
                                      <i className="fa fa-eye"></i>
                                      </span>  
                                </button>
                                
                                <button 
                                      type="submit" 
                                      className="btn btn-link" 
                                      onClick= {()=> DEscargarEstudios() }
                                      
                                      ><span className="input-group-text" id="basic-addon">
                                      <i className="fa fa-download"></i>
                                      </span> 
                                  </button>   
                                  <button 
                                      type="submit" 
                                      className="btn btn-link"
                                      
                                      ><Link to={'/envioCorreo'}>
                                        <span className="input-group-text" id="basic-addon">
                                     <i className="fa fa-envelope-o"></i>
                                                 
                                      </span> 
                                      </Link>
                                  </button>  
                          </div>
                      </tr>
                 </Fragment>
        );
    
};

export default Ordenpaciente;